import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFailed = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24 40L40 24",
		stroke: "currentColor",
		strokeWidth: 4
	}), /* @__PURE__ */ _jsx("path", {
		d: "M40 40L24 24",
		stroke: "currentColor",
		strokeWidth: 4
	})]
});
const ForwardRef = forwardRef(SvgFailed);
export default ForwardRef;
